import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Spin } from 'antd';
import { useAuth } from '../../auth/AuthProvider';
import { api, errorMessage } from '../../api/client';
import { AuthCard } from '../../components/AuthCard';

export function ForgotPasswordPage() {
  const { status } = useAuth();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (status === 'loading') return <div className="auth-screen"><Spin size="large" /></div>;
  // signed-in users change their password from their account page
  if (status === 'authenticated') return <Navigate to="/account" replace />;

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    setError(null);
    try {
      await api.post('/auth/forgot-password', values);
      setSent(true);
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Reset your password" subtitle="We'll email you a link to choose a new password.">
      {error && <Alert type="error" title={error} style={{ marginBottom: 16 }} showIcon />}
      {sent ? (
        <Alert type="success" showIcon title="If an account exists for that email, a reset link is on its way." />
      ) : (
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input autoFocus autoComplete="email" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Send reset link
          </Button>
        </Form>
      )}
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <Link to="/login">Back to sign in</Link>
      </div>
    </AuthCard>
  );
}
